import React, { useState, useRef } from "react";
import "./index.css";

const GroupedSelect = ({
  options,
  onChange,
  searchTerm,
  opendDropdown,
  optionsLoading,
}) => {
  const [activeTab, setActiveTab] = useState("Accounts");
  const [collapsedGroups, setCollapsedGroups] = useState([]);
  const selectContainerRef = useRef(null);

  const handleSelection = (group, value) => {
    if (onChange) onChange(group, value);
    setCollapsedGroups([]);
  };

  const toggleGroupCollapse = (groupIndex) => {
    setCollapsedGroups((prev) =>
      prev.includes(groupIndex)
        ? prev.filter((index) => index !== groupIndex)
        : [...prev, groupIndex]
    );
  };

  const groupedSelectOptionKey = (groupLabel, option, index) => {
    if (option?.id != null && String(option.id) !== "") {
      return `${groupLabel}-id-${String(option.id)}`;
    }
    const v = option?.value;
    if (groupLabel !== "Payments" && v != null && String(v) !== "") {
      return `${groupLabel}-val-${String(v)}-${index}`;
    }
    return `${groupLabel}-row-${index}-${String(option?.label ?? "")}`;
  }

  const filteredOptions =
    options &&
    options
      .map((group, index) => ({
        label: group.label,
        options: group.options && group.options,
        index,
      }))
      .filter(
        (group) =>
          group.options && group.options.length > 0 && group.label === activeTab
      );

  return (
    <div className='grouped-select-container' ref={selectContainerRef}>
      {(searchTerm || (options && options.length > 0)) && (
        <>
          <div className='tab-navigation'>
            <button
              className={`tab ${activeTab === "Accounts" ? "active" : ""}`}
              onClick={() => setActiveTab("Accounts")}
            >
              Accounts
            </button>
            <button
              className={`tab ${activeTab === "Invoices" ? "active" : ""}`}
              onClick={() => setActiveTab("Invoices")}
            >
              Invoices
            </button>
            <button
              className={`tab ${activeTab === "Payments" ? "active" : ""}`}
              onClick={() => setActiveTab("Payments")}
            >
              Payments
            </button>
            <button
              className={`tab ${activeTab === "Credit Memos" ? "active" : ""}`}
              onClick={() => setActiveTab("Credit Memos")}
            >
              Credit Memos
            </button>
          </div>

          <div className='tab-content'>
            {filteredOptions.length > 0 ? (
              <div className='options-scroll-container'>
                {filteredOptions.map((group) => (
                  <div key={group.index} className='group'>
                    {!collapsedGroups.includes(group.index) && (
                      <div className='options-container'>
                        {group.options.map((option, index) => {
                          const isNestedAccount =
                            group.label === "Accounts" &&
                            typeof option.depth === "number" &&
                            option.depth > 0;
                          return (
                            <div
                              key={groupedSelectOptionKey(
                                group.label,
                                option,
                                index
                              )}
                              className={
                                isNestedAccount
                                  ? "option option--account-nested"
                                  : "option"
                              }
                              style={
                                isNestedAccount
                                  ? {
                                    paddingLeft: 8 + option.depth * 18,
                                  }
                                  : undefined
                              }
                              onClick={() => handleSelection(group.label, option)}
                            >
                              {isNestedAccount && (
                                <span
                                  className='account-search-bullet'
                                  aria-hidden
                                />
                              )}
                              <span className='option-label-text'>
                                {highlightMatch(option.label, searchTerm)}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : optionsLoading ? (
              <div className='spinner'></div>
            ) : (
              <div className='no-options'>{` ${searchTerm} not found in ${activeTab}`}</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const highlightMatch = (text, term) => {
  if (!term) return <span className='genText'>{text}</span>;

  const escapedTerm = term.replace(/[*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escapedTerm})`, "gi");

  const processTextPart = (part, index) => {
    if (regex.test(part)) {
      return part.split(regex).map((subPart, subIndex) =>
        regex.test(subPart) ? (
          <span key={`${index}-${subIndex}`} className='highlight'>
            {subPart}
          </span>
        ) : (
          <span key={`${index}-${subIndex}`} className='genText'>
            {subPart}
          </span>
        )
      );
    }
    return (
      <span key={index} className='genText'>
        {part}
      </span>
    );
  };

  const parts = text.split(/AddressString:/i);
  if (parts.length > 1) {
    const [beforeAddress, afterAddress] = parts;
    return (
      <>
        {beforeAddress.split(/(\d{1,3}(?:,\d{3})*)/).map(processTextPart)}
        <br></br>
        <span className='address'>{afterAddress}</span>
      </>
    );
  }

  return text.split(/(\d{1,3}(?:,\d{3})*)/).map(processTextPart);
};

export default GroupedSelect;
